<template>
<transition  appear name="fade">
<div class="container">
    <div class="row">
        <div class="column">
            <img class="prize" :src="image_src" />
            <br>
            <router-link :to="{name: 'home'}">
                <button>OK</button>
            </router-link>
        </div>
    </div>
</div>
</transition>
</template>

<script>
export default{
    name: 'prize',
    data() {
        return{
            image_src: require("../assets/img/prize/" + this.$store.state.getPrize + "_2.png"),
        }
    },
}
</script>

<style scoped>
.fade-enter-active {
  animation: fade-in 1s ease-out;
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.row{
    text-align: center;
}
.prize{
    width: 50%;
}
@media (max-width: 400px) {
    .prize{
        width: 100%;
    }
}
</style>